import React from 'react';
import { useTranslation } from 'react-i18next';
import { RootTeamMemberInfo } from '../..';
import { LevelZeroTopInfo } from '../../../MyTeamBackofficeStyled';
import { getLegStregthsL } from '../../../utils';
import { LegInfo } from './LegInfo/LegInfo';
import { LevelZeroWrap } from './LevelZero.styles';
import { UserProfile } from './UserProfile';

export const LevelZero = ({ teamMember, teamMemberInfo, tab }) => {
  const { t } = useTranslation('myTeam');
  const [leftLegStrenght, rightLegStrength] = getLegStregthsL(teamMember);

  return (
    <div>
      <LevelZeroTopInfo>
        <RootTeamMemberInfo tab={tab} />
      </LevelZeroTopInfo>
      <LevelZeroWrap>
        <LegInfo
          legName={
            <>
              {t('left_team')} {leftLegStrenght}
            </>
          }
          legInfo={teamMemberInfo?.leftLegInfo}
          todayLegTotalVolume={teamMember?.todayLeftLegTotalVolume}
        />
        <UserProfile teamMember={teamMember} teamMemberInfo={teamMemberInfo} />
        <LegInfo
          legName={
            <>
              {t('right_team')} {rightLegStrength}
            </>
          }
          legInfo={teamMemberInfo?.rightLegInfo}
          todayLegTotalVolume={teamMember?.todayRightLegTotalVolume}
        />
      </LevelZeroWrap>
    </div>
  );
};
